import { getPrimaryBgColor } from '../../utils/color.js';

var CTAColors = {
  primary: "#07098d",
  primaryVariant: "#0065ff",
  primaryBg: getPrimaryBgColor("#07098d")
};
var neutralColors = {
  charcoal: "#343a40",
  smoke: "#535b64",
  rhino: "#868e96",
  silver: "#cfd4da",
  pearl: "#f3f4f6",
  white: "#ffffff",
  porcelain: "#ECEEF0"
};
var alertColors = {
  information: "#178af7",
  success: "#008a1f",
  warning: "#ffc107",
  error: "#e71d32"
};

export { CTAColors, alertColors, neutralColors };
